







import { Component, Prop, Vue } from "vue-property-decorator";

// The single confirmation under a list after marking something, with "Undo" or "Retry".
@Component
export default class CzUndoBar extends Vue {
  @Prop({ type: String, default: "" }) message!: string;
  @Prop({ type: String, default: "" }) action!: string;
  @Prop({ type: Boolean, default: false }) error!: boolean;
}
